
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_rjqu5_1kbym_5",
  "header-actions": "awsui_header-actions_rjqu5_1kbym_6",
  "header-before": "awsui_header-before_rjqu5_1kbym_7",
  "header-description": "awsui_header-description_rjqu5_1kbym_8",
  "header-info": "awsui_header-info_rjqu5_1kbym_9",
  "header-text": "awsui_header-text_rjqu5_1kbym_10",
  "open-button": "awsui_open-button_rjqu5_1kbym_11",
  "close-button": "awsui_close-button_rjqu5_1kbym_12",
  "preferences-button": "awsui_preferences-button_rjqu5_1kbym_13",
  "slider": "awsui_slider_rjqu5_1kbym_14",
  "open-position-bottom": "awsui_open-position-bottom_rjqu5_1kbym_15",
  "open-position-side": "awsui_open-position-side_rjqu5_1kbym_16"
};
  